import { CalendarSettingsViewModel } from "../../calendar-settings/api/calendar-settings"
import { createHolidayChecker, getHolidayNameForDate } from "../../calendar-settings/utils/date"

type Translations = {
  abbreviatedDayNames: string[]
  fullMonthNames: string[]
}

type CreateDateScaleTemplateFnArgs = {
  calendarSettings: CalendarSettingsViewModel
  translations: Translations
  showMonthName?: boolean
}

type DateScaleTemplate = (date: Date) => string

export const createDateScaleTemplate = ({
  calendarSettings,
  showMonthName = true,
  translations,
}: CreateDateScaleTemplateFnArgs): DateScaleTemplate => {
  const checkIsHoliday = createHolidayChecker(calendarSettings)
  const getHolidayName = (date: Date): string => getHolidayNameForDate(date, calendarSettings)

  return (date: Date): string => {
    const dayOfWeek = date.getDay() as DayOfWeek
    const day = date.getDate()
    const month = date.getMonth()

    const dayName = translations.abbreviatedDayNames[dayOfWeek]
    const monthName = translations.fullMonthNames[month]

    const isHoliday = checkIsHoliday(date)
    const holidayName = getHolidayName(date)
    const textToDisplay = `${dayName} ${day} ${showMonthName ? monthName : ""}`

    return isHoliday
      ? `<span data-tooltip="${holidayName}" class="custom-tooltip"><span class="overflow-hidden">${textToDisplay}<img src="/info.svg"></span></span>`
      : `<span class="overflow-hidden">${textToDisplay}</span>`
  }
}
